var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 5.25C10.2989 5.25 10.5976 5.36401 10.8253 5.59153L17.9916 12.758C18.4475 13.2139 18.4475 13.953 17.9916 14.4087C17.5359 14.8644 16.7969 14.8644 16.341 14.4087L10.0003 8.06747L3.65935 14.4082C3.20366 14.8639 2.46458 14.8639 2.00894 14.4082C1.55284 13.9525 1.55284 13.2137 2.00894 12.7578L9.17511 5.59127C9.40296 5.36379 9.70162 5.25 10.0003 5.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default ForwardRef;